import React from "react";
import { Clock, CalendarDays, Save, CheckCircle2 } from "lucide-react";

export default function MyHoursTab({
  loading,
  myHours,
  onChangeMyHours,
  myMaxBookingDays,
  onChangeMaxBookingDays,
  dayNames,
  myClosedDays,
  onToggleClosedDay,
  onSave,
  saving,
  updated,
}) {
  return (
    <div>
      <h2 className="section-title">Çalışma Saatlerim</h2>
      <p className="section-subtitle" style={{ marginTop: 0 }}>
        Kendi çalışma saatlerinizi ve kapalı günlerinizi ayarlayın.
        Müşteriler randevu alırken bu saatler dikkate alınır.
      </p>

      <div className="settings-card">
        {loading ? (
          <div className="admin-empty" style={{ marginBottom: "1rem" }}>
            <Clock />
            <p>Çalışma saatleri yükleniyor...</p>
          </div>
        ) : null}

        <h3 className="settings-card-title">
          <Clock /> Çalışma Saatleri
        </h3>
        <div className="settings-grid">
          <div>
            <label>Başlangıç Saati</label>
            <input
              type="time"
              value={myHours.start}
              onChange={(e) => onChangeMyHours("start", e.target.value)}
            />
          </div>
          <div>
            <label>Bitiş Saati</label>
            <input
              type="time"
              value={myHours.end}
              onChange={(e) => onChangeMyHours("end", e.target.value)}
            />
          </div>
          <div>
            <label>En Fazla Kaç Gün Sonrasına Randevu</label>
            <input
              type="number"
              min="1"
              max="365"
              value={myMaxBookingDays}
              onChange={(e) => onChangeMaxBookingDays(e.target.value)}
              placeholder="Boş bırakılırsa 10 gün"
            />
          </div>
        </div>

        <h3 className="settings-card-title" style={{ marginTop: "1.5rem" }}>
          <CalendarDays /> Kapalı Günler
        </h3>
        <p style={{ fontSize: "0.8125rem", color: "#94a3b8", marginBottom: "0.75rem" }}>
          Çalışmadığınız günleri seçin. Bu günlerde randevu alınamaz.
        </p>
        <div className="closed-days-grid">
          {dayNames.map((name, idx) => (
            <button
              key={idx}
              onClick={() => onToggleClosedDay(idx)}
              className={`closed-day-btn ${myClosedDays.includes(idx) ? "closed" : "open"}`}
            >
              {name}
              <span className="closed-day-status">
                {myClosedDays.includes(idx) ? "Kapalı" : "Açık"}
              </span>
            </button>
          ))}
        </div>

        <button onClick={onSave} className="btn-save" disabled={saving || loading}>
          <Save />
          {saving ? "Kaydediliyor..." : "Kaydet"}
        </button>
        {updated && (
          <p className="success-msg">
            <CheckCircle2 />
            Çalışma saatleriniz güncellendi.
          </p>
        )}
      </div>
    </div>
  );
}
